import { useMutation } from '@tanstack/react-query';
import { getAxios, getBaseUrl } from 'api/axios-client';
import { AxiosProgressEvent } from 'axios';

export const useNewUploadFile = (
    onUploadProgress: (progress: AxiosProgressEvent) => void
) => {
    const mutateFn = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return getAxios().post(
            `${getBaseUrl()}/api/v1/interview/files/general`,
            formData,
            {
                onUploadProgress,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
    };
    return useMutation({
        mutationKey: ['upload_file_new'],
        mutationFn: mutateFn,
    });
};
